<template>
  <div class="min-h-screen bg-[#FFF7EF]">
    <div class="mx-auto max-w-3xl px-4 py-16 lg:px-8">
      <section class="rounded-3xl border border-gray-100 bg-white p-8 shadow-sm">
        <p class="text-xs font-semibold uppercase tracking-[0.2em] text-muted">Password reset</p>
        <h1 class="mt-3 text-3xl font-semibold text-ink">Reset your password</h1>
        <p class="mt-2 text-sm text-muted">
          Enter the email you use for Invi8 and we will send a reset link.
        </p>

        <form class="mt-6 space-y-4" @submit.prevent="handleSubmit">
          <label class="block">
            <span class="text-xs font-semibold uppercase tracking-wide text-muted">Email</span>
            <input
              v-model="email"
              type="email"
              required
              placeholder="you@invi8.co"
              class="mt-2 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm text-ink shadow-sm focus:border-brand focus:outline-none"
            >
          </label>

          <button
            type="submit"
            class="w-full rounded-full bg-brand px-4 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-brandDark"
          >
            Send reset link
          </button>
        </form>

        <div v-if="sent" class="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
          Reset link sent to <span class="font-semibold">{{ email }}</span>.
        </div>

        <div class="mt-6 text-center text-xs text-muted">
          Remembered it?
          <RouterLink class="font-semibold text-brand" to="/login">Back to login</RouterLink>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const email = ref('')
const sent = ref(false)

const handleSubmit = () => {
  sent.value = true
}
</script>
